<template>
  <el-container class="form-notice-manege pagination-list">
    <el-main>
      <div class="content">
        <el-form :inline="true" @submit.native.prevent>
          <el-form-item label="关键字">
            <el-input v-model="conditions.keyword" placeholder="请输入关键字" @keyup.enter.native="search" clearable/>
          </el-form-item>
          <el-form-item>
            <el-button @click="search" type="primary">查询</el-button>
          </el-form-item>
        </el-form >
        <el-table class="table-list" :data="items" v-loading="loading" height='100%' width="100%">
          <el-table-column prop="name" label="表单名称" align="center"></el-table-column>
          <el-table-column prop="setting" label="是否设置" align="center"></el-table-column>
          <el-table-column label="操作" align="center" width="200">
            <template slot-scope="scope">
              <el-button type="text" @click="setCandidate(scope.row)">设置</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-footer height="32px" class="pagination-footer">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.currentPage"
            :page-sizes="pagination.pageSizes"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total">
          </el-pagination>
        </el-footer>
      </div>
    </el-main>
    <el-dialog class="form-notice-manege-dialog" title="通知设置" v-if="dialogNotice.visible" :visible.sync="dialogNotice.visible" width="560px" :close-on-click-modal="false" center>
      <form-notice ref="formNotices" :formNotices="dialogNotice.formNotices"></form-notice>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="comfire">确 定</el-button>
        <el-button @click="dialogNotice.visible = false">取 消</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>
<script>
import FormNotice from './form-notices.vue'
export default {
  name: 'FormNoticeManege',
  data () {
    return {
      conditions: { keyword: '' },
      items: [],
      loading: false,
      pagination: { currentPage: 1, pageSize: 20, pageSizes: [10, 20, 30, 50, 100], total: 0 },
      dialogNotice: {
        visible: false,
        formNotices: []
      }
    }
  },
  components: {
    FormNotice
  },
  created () {
    this.getTableData()
  },
  computed: {

  },
  methods: {
    search () {
      // 页数为 1
      this.pagination.currentPage = 1
      this.filters = {
        'keyword': this.conditions.keyword
      }
      this.getTableData()
    },

    // 调用接口获取tableData数据
    getTableData () {
      this.loading = true
      let page = this.pagination
      let params = {
        'index': page.currentPage,
        'size': page.pageSize
      }
      params.filters = this.filters
      this.$axios.get('/form-api/formNotice', {params})
        .then((res) => {
          // 页面数据改变重新统计数据数量和当前页
          this.pagination.total = res.data.total
          this.loading = false
          this.items = res.data.items
          if ((this.pagination.currentPage - 1) * this.pagination.pageSize >= this.pagination.total) {
            this.pagination.currentPage--
          }
        }).catch(() => {
          this.loading = false
        })
    },
    handleSizeChange (val) {
      this.pagination.pageSize = val
      this.getTableData()
    },
    handleCurrentChange (val) {
      this.pagination.currentPage = val
      this.getTableData()
    },
    setCandidate (row) {
      this.$axios.get(`/form-api/formNotice/${row.formId}`)
        .then((res) => {
          res.data.forEach((m) => {
            m.style = typeof (m.style) === 'string' ? JSON.parse(m.style) : m.style
            m.targets = typeof (m.targets) === 'string' ? JSON.parse(m.targets) : m.targets
          })
          this.dialogNotice.formNotices = res.data
          this.dialogNotice.visible = true
        }).catch(() => {
        })
    },
    comfire () {
      Promise.all(this.$refs.formNotices.validate()).then(() => {
        let formNotices = this.$_.cloneDeep(this.dialogNotice.formNotices)
        formNotices.forEach((el) => {
          el.style = JSON.stringify(el.style)
          el.targets = JSON.stringify(el.targets)
        })
        this.$axios.post(`/form-api/formNotice`, formNotices).then(res => {
          this.dialogNotice.visible = false
          this.getTableData()
        })
      })
    }

  }
}
</script>
<style lang="scss">
.form-notice-manege {
  .content .el-button {
    padding: 4px;
  }
}
 @import '@/assets/scss/common.scss';
</style>



// WEBPACK FOOTER //
// src/components/form/design/form-notice-manege.vue